<template>
	<v-app class="three-columns">
		<top-bar @toggle="toggle" />
		<left-bar-mobile v-if="$vuetify.breakpoint.mdAndDown"/>
		<error v-if="error" :code="error.code" :message="error.message" :url="error.url" :urlTitle="error.urlTitle" />
		<v-main class="background main">
			<div class="sou-container">
				<div class="main-left d-none d-lg-block">
					<left-bar-desktop v-if="$vuetify.breakpoint.mdAndUp"/>
				</div>
				<div class="main-main">
					<div class="sou-wall">
						<v-row class="my-0">
							<v-col cols="12" class="wall-center-column pt-0">
								<router-view></router-view>
							</v-col>
						</v-row>
					</div>
				</div>
			</div>
		</v-main>
		<floating-chat v-if="bubblesEnabled" />
	</v-app>
</template>
<script>
import TopBar from '@/components/top-bar/TopBar';
import LeftBarMobile from '@/components/left-bar/LeftBarMobile';
import LeftBarDesktop from '@/components/left-bar/LeftBarDesktop';
import Error from '@/components/Error';
import {mapGetters} from 'vuex';
import FloatingChat from '@/components/chat/FloatingChat';
export default {
	name: 'DefaultLayout',
	components: {
		'top-bar': TopBar,
		'left-bar-mobile': LeftBarMobile,
		'left-bar-desktop': LeftBarDesktop,
		Error,
		FloatingChat
	},
	computed: {
		...mapGetters({
			error: 'application/error',
			bubblesEnabled: 'chat/bubblesEnabled'
		})
	},
	methods: {
		toggle() {
			this.$refs.sidebar.toggle();
		},
	},
	mounted() {

	}

}
</script>
